<template>
  <tr>
    <td>

      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="grey"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
            </span>
          </div>
        </v-card>
      </v-menu>

      <text-highlight class="text-truncate" :queries="nameKeywords" highlightClass="color1--text" highlightStyle="background: none;">{{ item.name }}</text-highlight>

    </td>
    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue="item.quantity_sold"
      :key="(item.definition || {}).id"
      alwaysScale
      labelMode
      ></c-ms-ii>
    </td>
    <td>
      {{ item.sale_item_count }}
    </td>
    <td>
      {{ item.price_per_unit }}
    </td>
    <td>
      {{ item.value }}
    </td>
  </tr>
</template>

<script>
import TextHighlight from 'vue-text-highlight'

export default {
  props: ['item', 'searchFilters'],
  components: {
    TextHighlight
  },
  data () {
    return {
      
    }
  },
  computed: {
    nameKeywords () {
      return (this.searchFilters.name || '').trim().split(/\s+/)
    }
  }
}
</script>